import {styled} from '@esgi/ui/theme';
import {GridBox} from '@esgi/ui/layout';

export const SettingsBox = styled(GridBox, {
	gridTemplateColumns: '230px 170px 200px',
	gap: '8px',
	gridAutoFlow: 'row',
});